import { AnchorLocation } from './anchorLocation.enum';

export class AnchorLocations {

  public static getNorth(): Array<AnchorLocation> {
    return [
      AnchorLocation.NORTH,
      AnchorLocation.NORTH_EAST,
      AnchorLocation.NORTH_WEST,
    ];
  }

  public static getSouth(): Array<AnchorLocation> {
    return [
      AnchorLocation.SOUTH,
      AnchorLocation.SOUTH_EAST,
      AnchorLocation.SOUTH_WEST,
    ];
  }

  public static getEast(): Array<AnchorLocation> {
    return [
      AnchorLocation.EAST,
      AnchorLocation.NORTH_EAST,
      AnchorLocation.SOUTH_EAST,
    ];
  }

  public static getWest(): Array<AnchorLocation> {
    return [
      AnchorLocation.WEST,
      AnchorLocation.NORTH_WEST,
      AnchorLocation.SOUTH_WEST,
    ];
  }

  public static getXCenter(): Array<AnchorLocation> {
    return [
      AnchorLocation.NORTH,
      AnchorLocation.CENTER,
      AnchorLocation.SOUTH,
    ];
  }

  public static getYCenter(): Array<AnchorLocation> {
    return [
      AnchorLocation.WEST,
      AnchorLocation.CENTER,
      AnchorLocation.EAST,
    ];
  }

  public static getX(xLocation: AnchorLocation): Array<AnchorLocation> {
    if (this.getEast().includes(xLocation)) {
      return this.getEast();
    } else if (this.getWest().includes(xLocation)) {
      return this.getWest();
    } else {
      return this.getXCenter();
    }
  }

  public static getY(location: AnchorLocation): Array<AnchorLocation> {
    if (this.getNorth().includes(location)) {
      return this.getNorth();
    } else if (this.getSouth().includes(location)) {
      return this.getSouth();
    } else {
      return this.getYCenter();
    }
  }
}
